import {
  Form,
  Space,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import BannerForm from '../../forms/BannerForm';
import { editBanner, getBanner } from '../../services/bannerServices';

function EditBanner() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    const res = await getBanner(id);
    if (res.status === 'success') {
      if (res.data.banner_image_path_ka) {
        res.data.banner_image_ka = {
          fileList: [{
            uid: 1,
            url: res.data.banner_image_path_ka,
            name: res.data.title_ka,
          }],
        };
      }
      if (res.data.banner_image_path_en) {
        res.data.banner_image_en = {
          fileList: [{
            uid: 1,
            url: res.data.banner_image_path_en,
            name: res.data.title_en,
          }],
        };
      }
      if (res.data.banner_image_path_ru) {
        res.data.banner_image_ru = {
          fileList: [{
            uid: 1,
            url: res.data.banner_image_path_ru,
            name: res.data.title_ru,
          }],
        };
      }
      form.setFieldsValue(res.data);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      setErrors([]);
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (values[key]) {
          if (key.includes('image')) {
            formData.append(key, values[key].file);
          } else {
            formData.append(key, values[key]);
          }
        }
      });
      const res = await editBanner(id, formData);
      if (res.status === 'success') {
        navigate('/admin/banners');
      }
    } catch (e) {
      setErrors(e.response.data.errors);
    }
    setIsLoading(false);
  };

  return (

    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined
        style={{ fontSize: '20px' }}
        onClick={() => navigate('/admin/banners')}
      />
      <BannerForm
        form={form}
        errors={errors}
        handleSubmit={handleSubmit}
        loading={isLoading}
      />
    </Space>
  );
}

export default EditBanner;
